export default __webpack_public_path__ + "static/media/TF_00.034e000f.png";